import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { IErrorCode, IShareData, ISharememberInviteData } from 'src/sync';
import { ErrCode, MultiAdminUserData, MultiSelectItem, PermissionActions, Role } from '../../models';
import { UserService } from 'src/app/core/user.service';
import { ApiService } from 'src/app/core/api.service';
import { LoggerService } from 'src/app/core/logger.service';
import { MultiAdminService } from 'src/app/core/multiadmin.service';
import { ValidateService } from 'src/app/core/validate.service';
import { debounceTime, map, Observable } from 'rxjs';
import { AutoSuggestionConfig } from '@material-library';
import { ChargebeeService } from '../../services/chargebee.service';

@Component({
  selector: 'app-share-member-add',
  templateUrl: './share-member-add.component.html',
  styleUrls: ['./share-member-add.component.scss']
})
export class ShareMemberAddComponent implements OnInit {
  @Output() shareMemberInviteChange: EventEmitter<ISharememberInviteData> = new EventEmitter<ISharememberInviteData>();
  @ViewChild('eventItemRef') eventItemRef: TemplateRef<any>;
  @ViewChild('shareWithItemRef', { static: true }) shareWithItemRef: TemplateRef<any>;

  @Input() public sharememberInvite: ISharememberInviteData;
  @Input() public shareData: IShareData;
  @Input() public closeDialog?:Function;
  public errors: Array<IErrorCode> = [];
  public spinner: boolean;

  public isPro = false;
  public isVerified = false;

  // must be initialized as an array or email validation fails.
  public contacts: Array<string> = [];
  public invitedUserIds: Array<number> = [];
  public permission = '1';
  public disableValidation = false;
  public isOnTrial = false;
  public permissionActions = PermissionActions;
  public isRolesAllowed: Boolean = false;
  public rolesList: MultiSelectItem[] = [];
  public selectedRoleNames: string[] = [];
  public teamUsers: MultiAdminUserData[] = [];

  public isLoading = true;


  public emailItems: string[] = [];
  public prevShareWithChipItems = [];
  public shareWithChipItems = [];
  public shareWithAutoSuggestionConfig: AutoSuggestionConfig
  public shareWithTriggerCallback: any = {
    addChipInputValidate: (value: string, chipItems: string[]) => {
      const isEmail: boolean = this.validateEmail(value);
      const duplicateExists = chipItems.includes(value);

      if (duplicateExists) {
        this.shareWithValidationErrorMessage = isEmail ? 'Email already added.' : 'Role already added.'
        return {
          isInvalid: true,
          message: this.shareWithValidationErrorMessage
        };
      }

      if (!isEmail) {
        const isValidRole = this.rolesList.some((role) => role.name === value);
        if (!isValidRole) {
          this.shareWithValidationErrorMessage = 'Choose an option from the list or enter a valid email address.';
        } else {
          this.shareWithValidationErrorMessage = '';
        }
        
        return { isInvalid: !isValidRole, message: this.shareWithValidationErrorMessage };
      }
      else {
        this.shareWithValidationErrorMessage = '';
        return { isInvalid: false, message: this.shareWithValidationErrorMessage };
      }
    },
  };
  public shareWithValidationErrorMessage: string = '';
  public shareWithAutoSuggestionItems = []
  private loadCount: number;

  constructor(
    private userService: UserService,
    private apiService: ApiService,
    private loggerService: LoggerService,
    private multiadminService: MultiAdminService,
    private validateService: ValidateService,
    private chargebeeService: ChargebeeService,
  ) { }


  async ngOnInit() {
    this.shareWithAutoSuggestionConfig  = {
      displayKey: 'value',
      valueFunction: (item) => item.value,
      templateRef: this.shareWithItemRef,
    }



    this.isPro = (this.userService.get('is_pro'));
    this.isVerified = (this.userService.get('is_verified'));
    this.isOnTrial = (this.userService.get('is_on_trial'));
    this.loadCount = 1;
    this.apiService.execute<any>('contactlist', {}).then((data) => {
      const contactEmails = data.contacts.map((val: any) => val.value);
      this.contacts = [...this.contacts, ...contactEmails].sort((a, b) => a.localeCompare(b));
      --this.loadCount;
      this.updateShareWIthChipAutoSuggestionItems();
    });
    this.isRolesAllowed = this.userService.get('is_multi_new') && this.checkPermission(this.permissionActions.VIEW_ROLES) && this.userService.get('is_unlimited_plan');
    this.invitedUserIds = this.shareData && this.shareData.people ? this.shareData.people.filter(value => value.user_status_id === 1).map((val: any) => val.userId) : [];
    if (this.isRolesAllowed) {
      ++ this.loadCount;
      await this.getUsersList();
      await this.getRolesList();
      --this.loadCount;
      this.updateShareWIthChipAutoSuggestionItems();
    }
    this.defaultPermissionChanged();
    if(!this.isPro){
      this.permissionChanged(true,'perUPLOAD');
    }
    this.isLoading = false;
  }

  private validateEmail = (email: String) => {
    return !!String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  onShareWithItemChange = (items: string[]) => {
    this.shareWithChipItems = [...items];
    const removed = this.prevShareWithChipItems.filter((item) => !items.includes(item))[0];
    this.prevShareWithChipItems = [...this.shareWithChipItems];

    if (removed) {
      if (removed.includes('@')) {
        this.removePerson(removed);
      }
      else {
        this.onRoleSelect(this.selectedRoleNames.filter((role) => role !== removed).map((role) => {
          return {
            name: role
          }
        }));
      }
    }
    else {
      const emails = items.filter((item) => item.includes('@'));
      const eLength = emails.length;
      if (eLength) {
        const email = emails[eLength - 1]
        if (this.queueInvite(email)) {
          this.emailItems = emails;
          this.sharememberInvite.queue = this.emailItems;
        };
      }
  
      const roles = items.filter((item) => !item.includes('@'));
      this.onRoleSelect(roles.map((role) => {
        return {
          name: role
        }
      }));
    }

    this.shareMemberInviteChange.next(this.sharememberInvite);
  }

  shareWithChipConfig = (item: string, config) => {
    if (item.includes('@')) {
      return {
        value: item,
        ...config,
        leadAdornments: {
          enabled: true,
          type: 'avatar',
          size: 'small',
          avatarConfig: {
            type: 'avatar',
            size: 24,
            initials: item,
            randomColor: true,
          }
        }
      }
    }
    else {
      return {
        value: `${item} (Role)`,
        ...config,
        leadAdornments: {
          enabled: true,
          type: 'icon',
          iconType: 'default',
          iconName: 'role',
          size: 'small',
        }
      }

    }

  }

  updateShareWIthChipAutoSuggestionItems = () => {
    if (!this.loadCount) {
      const uniqueItems = new Map<string, any>();
      const uniqueRoleItems = new Map<string, any>();

      // Add contacts
      this.contacts.forEach(email => {
        uniqueItems.set(email, { type: 'contact', value: email, email });
      });

      // Add team users (excluding current user)
      this.teamUsers
        .filter(user => user.email !== this.userService.get('email'))
        .forEach(user => {
          uniqueItems.set(user.email, { type: 'contact', value: user.email, email: user.email });
        });

      // Add roles with users
      this.rolesList
        .filter(role => role['users'].length)
        .forEach(role => {
          uniqueRoleItems.set(role.name, { type: 'role', value: role.name, role });
        });

      this.shareWithAutoSuggestionItems = [
        ...Array.from(uniqueRoleItems.values()).sort((a, b) => a.value.localeCompare(b.value)),
        ...Array.from(uniqueItems.values()).sort((a, b) => a.value.localeCompare(b.value))];
    }
  }

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      map(term => term === '' ? []
        : this.contacts.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
    )

  permissionChanged(checked: boolean, permission: 'perUPLOAD' | 'perSEEOTHERS' | 'perADDAPP' | 'perOWNER' | 'perINVITE') {
    this.sharememberInvite.permissions[permission] = checked ? 1 : 0;
  }

  public togglePerm(perm: string) {
    if (perm == 'perUPLOAD' && !this.isPro) {
      this.loggerService.info('PER UPLOAD BUT user is not pro');
      return false;
    }

    this.sharememberInvite.permissions[perm] = (this.sharememberInvite.permissions[perm]) ? 0 : 1;
  }

  public getContactName(email: string) {
    for (let i = 0, len = this.contacts.length; i < len; i++) {
      if (this.contacts[i].toLowerCase() == email.toLowerCase()) {
        return this.contacts[i];
      }
    }
    return email;
  }

  public removePerson(email: string) {
    this.sharememberInvite.queue.splice(this.sharememberInvite.queue.indexOf(email.toLowerCase()), 1);
  }

  onFocus() {
    this.disableValidation = false;
  }

  private queueInvite = (email: string): boolean => {
    this.disableValidation = true;
    if (!email) { return false; }
    this.errors = [];
    email = email.toLowerCase();
    if (!this.validateService.isEmail(email)) {
      // f.controls['email'].setErrors({ 'email': true });
      // set error
      return false;
    }
    if (email == this.userService.get('email').toLowerCase()) {
      this.errors.push({
        code: 1650
      });
      this.loggerService.error('cannot queue yourself');
      return false;
    }
    if (this.shareData && this.shareData.people && this.shareData.people.length) {
      for (let i = 0, len = this.shareData.people.length; i < len; i++) {
        const person = this.shareData.people[i];
        if (person.email.toLowerCase() == email &&
          person.status == 'Active') {
          this.errors.push({
            code: 1651,
            msg: `The user ${email} is already on this share`
          });
          this.loggerService.warn('${email}  is already on the share');
          return false;
        }
      }
    }
    if (this.sharememberInvite.queue.length) {
      this.sharememberInvite.queue.map((val) => {
        if (val == email) {
          this.errors.push({
            code: 1653,
            msg: `The user ${email} is in your invite queue already`
          });
          this.loggerService.error('this person is already queued');
          return false;
        }
      });
    }
    if (this.errors.length) { return false; }
    if (this.sharememberInvite.queue.length >= 20) {
      this.errors.push({
        code: 1652
      });
      return false;
    }
    this.sharememberInvite.queue.push(email);
    this.disableValidation = false;
    this.shareMemberInviteChange.next(this.sharememberInvite);
    return true;
  }

  public onRoleSelect(selectedRoles: MultiSelectItem[]) {
    this.sharememberInvite.roleQueue = [];
    this.sharememberInvite.roleName = '';
    this.selectedRoleNames = selectedRoles.map(role => role.name);
    this.sharememberInvite.roleName = this.selectedRoleNames.join(', ');

    this.teamUsers.forEach(user => {
      if (this.selectedRoleNames.includes(user.roles.toString()) && this.userService.get('email').toLowerCase() != user.email.toLowerCase() && !this.invitedUserIds.includes(user.user_id) && user.user_status_id === 1) {
        this.sharememberInvite.roleQueue.push(user.email);
      }
    });
  }

  public async getRolesList() {
    try {
      const response = await this.multiadminService.getRoles();
      const rolesList = (response as Role[])['roles'] as Role[];
      const multiSelectItems: MultiSelectItem[] = [];
      rolesList.forEach(role => {
        let multiSelectItem: MultiSelectItem;
        // Excluding current logged in user
        role.users = role.users.filter(user => user.user_id != this.userService.get('id') && !this.invitedUserIds.includes(user.user_id));
        multiSelectItem = role;
        multiSelectItem.displayName = `${role.name} (${role.users.length}${!role.users.length ? ' Users' :
          (role.users.length > 1 ? ' Users will be invited' : ' User will be invited')})`;
        multiSelectItem.disabled = role.users.length === 0;

        multiSelectItems.push(multiSelectItem);
      });
      this.rolesList = multiSelectItems;
    } catch (ex) {
      this.loggerService.error(ex);
      const error = ErrCode.fromException(ex);
      this.errors.push({
        code: error.code,
        msg: error.msg.toString()
      });
    }
  }

  public async getUsersList() {
    try {
      const result = await this.multiadminService.getUserList();
      this.teamUsers = result.users;
    } catch (ex) {
      this.loggerService.error(ex);
      const error = ErrCode.fromException(ex);
      this.errors.push({
        code: error.code,
        msg: error.msg.toString()
      });
    }
  }


  public checkPermission(permName: PermissionActions): boolean {
    return this.userService.checkPermission(permName);
  }

  get roleSelectedText(): string {
    if (!this.selectedRoleNames.length) {
      return '';
    }
    return `${this.selectedRoleNames.length}${this.selectedRoleNames.length == 1 ? ' role selected' : ' roles selected'}`;
  }
  onEmailChange = (data: string[]) => {    
    const eLength = data.length;
    if (eLength) {
      const email = data[eLength - 1]
      if (this.queueInvite(email)) {
        this.emailItems = data;
        this.sharememberInvite.queue = this.emailItems;
      };
    }
    this.shareMemberInviteChange.next(this.sharememberInvite);
  };
  onCheckCanEditChange = (env) => {
    const checked = env['checked']
    this.permissionChanged(checked, 'perUPLOAD')
  }
  onCheckCanInviteChange = (env) => {
    const checked = env['checked']
    this.permissionChanged(checked, 'perINVITE')
  }
  onCheckCanSeeOthersChange = (env) => {
    const checked = env['checked']
    this.permissionChanged(checked, 'perSEEOTHERS')
  }

  public privateMessageError: string = '';
  privateMessageErrorLength: number = 350;

  onChangeMessage = (privateMessage: string) => {
    this.sharememberInvite.privateMessage = privateMessage;
    this.privateMessageError = this.validErrorLength(privateMessage, this.privateMessageErrorLength, 'Message');
  };
  validErrorLength = (value: string, maxLength: number, type: string): string => {
    const str = value.trim();
    if (!str) {
      return type + ' cannot be empty.';
    }
    if (str.length > maxLength) {
      return type + ' cannot be empty.';
    }
    return '';
  };
  defaultPermissionChanged() {
    this.sharememberInvite.permissions.perDOWNLOAD = 1;
    this.sharememberInvite.permissions.perUPLOAD = 1;
    this.sharememberInvite.permissions.perSEEOTHERS = 1;
    this.sharememberInvite.permissions.perINVITE = 0;
    this.sharememberInvite.permissions.perADDAPP = 0;
  }
  close = ()=>{
    if(this.closeDialog){
      this.closeDialog();
    }
  }

  public openPortal = () => {
    this.chargebeeService.openPortal();
    this.close();
  }
}